const translations = {
  "en": {
    "Subscription": "Subscription"
  },
  "zh-tw": {
    "Subscription": "訂閱"
  }
};

export default translations;
